import { render, staticRenderFns } from "./CurrentProductsAvailability.vue?vue&type=template&id=22b05a80&scoped=true&"
import script from "./CurrentProductsAvailability.vue?vue&type=script&lang=js&"
export * from "./CurrentProductsAvailability.vue?vue&type=script&lang=js&"
import style0 from "./CurrentProductsAvailability.vue?vue&type=style&index=0&id=22b05a80&lang=scss&scoped=true&"
import style1 from "./CurrentProductsAvailability.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b05a80",
  null
  
)

export default component.exports